import Image from "../../components/elements/Image";
import CustomLink from "../../components/elements/CustomLink";
import FeaturesTiles from "../../components/sections/FeaturesTiles";
import { Helmet } from "react-helmet";

const features = [
  {
    title: "What is Drives?",
    content:
      "Drives transforms traditional sports gaming into an interactive experience, powered by dynamic, real-time scoring and wagering.",
  },
  {
    title: "Real-Time, Interactive Betting",
    content:
      "Drives markets convert the Drives Score into actionable, play-by-play wagering opportunities.",
  },
  {
    title: "Wisdom of the Crowd",
    content:
      "Market activity influences odds in real-time, creating a dynamic and adaptive experience driven by player engagement.",
  },
  {
    title: "Second-order Data",
    content:
      "Drives markets generate unique, proprietary data that enhances predictive accuracy, continually refining market performance both in-game and across future games.",
  },
  {
    title: "Dynamic Stat Markets",
    content:
      "The Drives methodology can extend to traditional statistics like Win Probability, turning static metrics into tradable markets.",
  },
  {
    title: "A Shared, Social Experience",
    content:
      "Unlike traditional sports gaming, Drives creates a universal scoring system that's intuitive and social for all users.",
  },
  {
    title: "Educational Gameplay",
    content:
      "The more fans engage with Drives, the deeper their understanding and appreciation of the game itself becomes.",
  },
];

export default function Home() {
  return (
    <section className="section about-section">
      <Helmet>
        <title>Home</title>
      </Helmet>
      <div className="w-full flex justify-center">
        <Image
          src={require("../../assets/images/drives.png")}
          alt="Features tile icon 02"
          width={400}
          height={300}
        />
      </div>

      <header className="lg:mt-5">
        <p className="text-gold text-center text-lg lg:text-4xl">
          The Next Evolution in Sports Gaming
        </p>

        <div className="flex justify-center">
          <CustomLink to="/broadcast">
            <Image
              src={require("../../assets/images/broadcast.png")}
              alt="Hero"
              width={800}
              height={300}
            />
          </CustomLink>
        </div>

        <p className="text-center lg:text-xl lg:mt-8 text-white">
          Where Content Becomes Gameplay, and Stats Become Live Markets.
        </p>
      </header>

      <div className="flex flex-col items-start justify-start w-full container mx-auto lg:mt-10">
        {features.map(({ title, content }, index) => (
          <p className="mb-32" key={index}>
            <strong className="text-gold">{title}</strong> {content}
          </p>
        ))}
      </div>

      <div className="mt-8">
        <FeaturesTiles />
      </div>
    </section>
  );
}
